import React, { useState, useEffect } from 'react';
import ProductsUpdateApprovalScreen from '../ProductsUpdateApproval/Screen/ProductsUpdateApprovalScreen';
import useNavActive from '../../components/Navbar/useNavActive';
import {
  getProductsUpdateRequest,
  getApprovedProductsUpdateRequest,
  getDeclinedProductsUpdateRequest,
  getProductsUpdateRequestApprove,
  getProductsUpdateRequestDecline,
} from '../../api/product.js';
import { getTableColumns, styles } from './const.js';
import ProductModal from './components/ProductModal.js';

export default function ProductsUpdateApproval() {
  useNavActive([
    'master_databases',
    'product_databases',
    'products_update_approval',
  ]);

  const [approvalData, setApprovalData] = useState([]);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [approvalTotalRows, setApprovalTotalRows] = useState(0);
  const [approvalPage, setApprovalPage] = useState(0);

  const [approvedData, setApprovedData] = useState([]);
  const [approvedLoading, setApprovedLoading] = useState(false);
  const [approvedTotalRows, setApprovedTotalRows] = useState(0);
  const [approvedPage, setApprovedPage] = useState(0);

  const [declinedData, setDeclinedData] = useState([]);
  const [declinedLoading, setDeclinedLoading] = useState(false);
  const [declinedTotalRows, setDeclinedTotalRows] = useState(0);
  const [declinedPage, setDeclinedPage] = useState(0);

  const [productModalShow, setProductModalShow] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [modalApproveBtn, setModalApproveBtn] = useState(false);
  const [modalDeclineBtn, setModalDeclineBtn] = useState(false);
  const [modalCloseBtn, setModalcloseBtn] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  const [activeTab, setActiveTab] = useState('approval');

  const defaultForm = {
    page_size: 50,
    page: 0,
    order_by: '',
    direction: '',
  };

  const [approvalPagePayload, setApprovalPagePayload] = useState({
    page_size: 50,
    page: approvalPage,
    order_by: '',
    direction: '',
  });

  const [approvedPagePayload, setApprovedPagePayload] = useState({
    page_size: 50,
    page: approvedPage,
    order_by: '',
    direction: '',
  });

  const [declinedPagePayload, setDeclinedPagePayload] = useState({
    page_size: 50,
    page: declinedPage,
    order_by: '',
    direction: '',
  });

  useEffect(() => {
    loadApprovalData(approvalPagePayload);
    loadApprovedData(approvedPagePayload);
    loadDeclinedData(declinedPagePayload);
  }, []);

  // APPROVAL TAB
  useEffect(() => {
    setApprovalPagePayload((prev) => ({ ...prev, page: approvalPage }));
  }, [approvalPage]);

  useEffect(() => {
    loadApprovalData(approvalPagePayload);
  }, [approvalPagePayload]);

  // APPROVED TAB
  useEffect(() => {
    setApprovedPagePayload((prev) => ({ ...prev, page: approvedPage }));
  }, [approvedPage]);

  useEffect(() => {
    loadApprovedData(approvedPagePayload);
  }, [approvedPagePayload]);

  // DECLINED TAB
  useEffect(() => {
    setDeclinedPagePayload((prev) => ({ ...prev, page: declinedPage }));
  }, [declinedPage]);

  useEffect(() => {
    loadDeclinedData(declinedPagePayload);
  }, [declinedPagePayload]);

  const loadApprovalData = async (params) => {
    setApprovalLoading(true);
    setApprovalData([]);

    try {
      const res = await getProductsUpdateRequest(params);

      const { code, total_rows, result } = res.data.response;

      setApprovalTotalRows(total_rows);
      setApprovalData(result);
      setApprovalLoading(false);
    } catch (error) {
      console.log('DATA: ', error);
    }
  };

  const loadApprovedData = async (params) => {
    setApprovedLoading(true);
    setApprovedData([]);

    try {
      const res = await getApprovedProductsUpdateRequest(params);

      const { code, total_rows, result } = res.data.response;

      setApprovedTotalRows(total_rows);
      setApprovedData(result);
      setApprovedLoading(false);
    } catch (error) {
      console.log('DATA: ', error);
    }
  };

  const loadDeclinedData = async (params) => {
    setDeclinedLoading(true);
    setDeclinedData([]);

    try {
      const res = await getDeclinedProductsUpdateRequest(params);

      const { code, total_rows, result } = res.data.response;

      setDeclinedTotalRows(total_rows);
      setDeclinedData(result);
      setDeclinedLoading(false);
    } catch (error) {
      console.log('DATA: ', error);
    }
  };

  const approveRequest = async (product_update_no) => {
    try {
      const res = await getProductsUpdateRequestApprove({
        product_update_no: product_update_no,
      });

      const { code, result } = res.data.response;

      if (code === 200) {
        setModalApproveBtn(false);
        setModalDeclineBtn(false);
        setModalcloseBtn(false);
        setModalLoading(false);
        setProductModalShow(false);

        loadApprovalData(approvalPagePayload);
        loadApprovedData();
        loadDeclinedData();
      } else {
        console.log('APPROVED1: ', result);
      }
    } catch (error) {
      console.log('APPROVED2: ', error);
    }
  };

  const declineRequest = async (product_update_no) => {
    try {
      const res = await getProductsUpdateRequestDecline({
        product_update_no: product_update_no,
      });

      const { code, result } = res.data.response;

      if (code === 200) {
        setModalApproveBtn(false);
        setModalDeclineBtn(false);
        setModalcloseBtn(false);
        setModalLoading(false);
        setProductModalShow(false);
      } else {
        console.log('DECLINE1: ', result);
      }
    } catch (error) {
      console.log('DECLINE2: ', error);
    }
  };

  const handleClickApprove = (selectedProduct) => {
    setModalApproveBtn(true);
    setModalDeclineBtn(true);
    setModalcloseBtn(true);
    setModalLoading(true);
    approveRequest(selectedProduct.product_update_no);
    loadApprovalData();
    loadApprovedData();
    loadDeclinedData();
  };

  const handleClickDecline = (selectedProduct) => {
    setModalApproveBtn(true);
    setModalDeclineBtn(true);
    setModalcloseBtn(true);
    setModalLoading(true);
    declineRequest(selectedProduct.product_update_no);
    loadApprovalData();
    loadApprovedData();
    loadDeclinedData();
  };

  const handleOpenProductModal = (product) => {
    setSelectedProduct(product);
    console.log('APPROVAL: ', approvalData);
    console.log('APPROVED: ', approvedData);
    console.log('DECLINED: ', declinedData);
    setProductModalShow(true);
  };

  const handleSelectActiveTab = (tab) => {
    setActiveTab(tab);
  };

  const columns = getTableColumns(handleOpenProductModal);

  return (
    <React.Fragment>
      <ProductsUpdateApprovalScreen
        columns={columns}
        approvalData={approvalData}
        approvalLoading={approvalLoading}
        approvalTotalRows={approvalTotalRows}
        approvalPage={approvalPage}
        setApprovalPage={setApprovalPage}
        approvedData={approvedData}
        approvedLoading={approvedLoading}
        approvedTotalRows={approvedTotalRows}
        approvedPage={approvedPage}
        setApprovedPage={setApprovedPage}
        declinedData={declinedData}
        declinedLoading={declinedLoading}
        declinedTotalRows={declinedTotalRows}
        declinedPage={declinedPage}
        setDeclinedPage={setDeclinedPage}
        activeTab={activeTab}
        handleSelectActiveTab={handleSelectActiveTab}
      />

      <ProductModal
        selectedProduct={selectedProduct}
        productModalShow={productModalShow}
        setProductModalShow={setProductModalShow}
        handleClickApprove={handleClickApprove}
        handleClickDecline={handleClickDecline}
        styles={styles}
        modalApproveBtn={modalApproveBtn}
        modalDeclineBtn={modalDeclineBtn}
        modalCloseBtn={modalCloseBtn}
        modalLoading={modalLoading}
      />
    </React.Fragment>
  );
}
